import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { useTracking } from "react-tracking";
import { startLoadingCatalogsAll } from "../../app/actions/catalogActions";
import { startLoadingCatalogModules } from "../../app/actions/catalogModuleActions";
import { startLoadingCatalogRoles } from "../../app/actions/catalogRoleActions";
import {
  moduleConfigurationStartDelete,
  selectModuleConfigurations,
  startLoadingModuleConfigurations,
  startLoadingModuleConfigurationsPaginated,
  startLoadingModuleConfigurationsPaginatedByFilters,
  startSearchingModuleConfigurationsPaginated,
} from "../../app/actions/moduleConfigurationActions";
import { debugLogPages } from "../../app/helpers/debugHelper";
import NavbarIconsModuleConfigurations from "../generic-nav-bar/NavbarIconsModuleConfigurations";
import SearchBackModuleConfiguration from "../generic-search/SearchBackModuleConfiguration";
import Pagination from "../generic-ui/Pagination";
import SimpleSelect from "../generic-ui/Select";
import TableModuleConfigurations from "./TableModuleConfigurations";
import ImportModuleConfigExcel from "./ImportModuleConfigExcel";

const ID_FORM = "admin-module-configuration";
const OPERATION = "list";

const listOptions = [2, 3, 4, 5, 10, 15, 20, 25, 50, 100];

const componentFilterInitialValues = {
  type: '',
  data_type: '',
  module_text: '',
  component_new: '',
  component_view: '',
}

const ListModuleConfigurations = () => {
  debugLogPages(':: ListModuleConfigurations');

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { trackEvent } = useTracking();
  const { t } = useTranslation();

  const { searchTextState, moduleConfigurationS, moduleConfigurationsP, totalPagesP, totalItemsP, currentPageP, totalPagesS, totalItemsS, currentPageS } =
    useSelector((state) => state.moduleConfig);

  const { listDataTypes, listTypeFields, listComponentNew, listComponentView,
    listCatalogModules
  } = useSelector((state) => state.catalog);

  const [, setCurrentPageClick] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [pageInitial] = useState(0);
  const [searchText, setSearchText] = useState(searchTextState || "");
  const [componentFilters, setComponentFilters] = useState(componentFilterInitialValues);
  const [isDisabledSearchText, setIsDisabledSearchText] = useState(false);
  const [isDisabledFilter, setIsDisabledFilter] = useState(false);
  const [activeTab, setActiveTab] = useState("list");

  useEffect(() => {
    dispatch(startLoadingModuleConfigurationsPaginated(pageInitial, itemsPerPage));
    dispatch(startLoadingModuleConfigurations());
    dispatch(startLoadingCatalogModules());
    dispatch(startLoadingCatalogRoles());
    dispatch(startLoadingCatalogsAll());

    setSearchText("");
  }, []);

  const onEditRow = (row) => {
    trackEvent({ component: "EditModuleConfigurations", method: "onEditRow", event: "EditModuleConfigurations-Clicked" });

    dispatch(selectModuleConfigurations(row));
    if (moduleConfigurationS && moduleConfigurationS.length > 0) {
      navigate("/admin-module-configuration/edit-module-configuration", {
        state: { searchTextNavListUser: searchText },
      });
    } else {
      navigate("/admin-module-configuration/edit-module-configuration");
    }
  };

  const onDeleteRow = (row) => {
    trackEvent({ component: "DeleteModuleConfigurations", method: "onDeleteRow", event: "DeleteModuleConfigurations-Clicked" });
    dispatch(moduleConfigurationStartDelete(row.id));
  };

  const onPageChange = (pageClick) => {

    if (moduleConfigurationS && moduleConfigurationS.length > 0) {
      dispatch(startSearchingModuleConfigurationsPaginated(searchText, pageClick - 1, itemsPerPage));
    } else {

      if (isAnyFilterSelected) {
        dispatch(startLoadingModuleConfigurationsPaginatedByFilters(pageClick - 1, itemsPerPage, processFiltersToSend()));
      } else {
        dispatch(startLoadingModuleConfigurationsPaginated(pageClick - 1, itemsPerPage));
      }

    }
    setCurrentPageClick(pageClick);
  };

  const onChangeSelect = (event) => {
    setItemsPerPage(event.target.value);
    if (moduleConfigurationS && moduleConfigurationS.length > 0) {
      dispatch(startSearchingModuleConfigurationsPaginated(searchText, 0, event.target.value));
    } else {
      if (isAnyFilterSelected) {
        dispatch(startLoadingModuleConfigurationsPaginatedByFilters(0, event.target.value, processFiltersToSend()));
      } else {
        dispatch(startLoadingModuleConfigurationsPaginated(0, event.target.value));
      }
    }
    setCurrentPageClick(0);
    setItemsPerPage(event.target.value);
  };

  const isAnyFilterSelected = () => {
    let flagIsAnyFilterSelected = false;

    if (componentFilters) {
      if (componentFilters.type) {
        flagIsAnyFilterSelected = true;
      } else if (componentFilters.data_type) {
        flagIsAnyFilterSelected = true;
      } else if (componentFilters.module_text) {
        flagIsAnyFilterSelected = true;
      } else if (componentFilters.component_new) {
        flagIsAnyFilterSelected = true;
      } else if (componentFilters.component_view) {
        flagIsAnyFilterSelected = true;
      }
    }

    return flagIsAnyFilterSelected;

  }

  const processFiltersToSend = () => {

    const componentFilterSend = {
      filters: {
        type: componentFilters && componentFilters.type && componentFilters.type.name,
        data_type: componentFilters && componentFilters.data_type && componentFilters.data_type.name,
        module_text: componentFilters && componentFilters.module_text && componentFilters.module_text.name,
        component_new: componentFilters && componentFilters.component_new && componentFilters.component_new.name,
        component_view: componentFilters && componentFilters.component_view && componentFilters.component_view.name,
      }
    }

    return componentFilterSend;

  }

  const customStyles = {
    option: (provided, state) => ({
      ...provided,

      fontSize: state.selectProps.myFontSize,
      fontWeight: state.selectProps.myFontWeight,
    }),
    singleValue: (provided, state) => ({
      ...provided,

      fontSize: state.selectProps.myFontSize,
      fontWeight: state.selectProps.myFontWeight,
    }),
  };

  const handleChangeComponentFilter = (event, field) => {
    //console.log("--->handleChangeComponentFilter, event, field", event, field);
    if (event != null) {

      setIsDisabledSearchText(true);
      setIsDisabledFilter(false);

      const componentFilterSend = {
        filters: {
          type: componentFilters && componentFilters.type && componentFilters.type.name,
          data_type: componentFilters && componentFilters.data_type && componentFilters.data_type.name,
          module_text: componentFilters && componentFilters.module_text && componentFilters.module_text.name,
          component_new: componentFilters && componentFilters.component_new && componentFilters.component_new.name,
          component_view: componentFilters && componentFilters.component_view && componentFilters.component_view.name,
          [field]: event.name,
        }
      }

      //console.log("3333, componentFilterSend", componentFilterSend)

      setComponentFilters((values) => ({ ...values, [field]: event }));

      dispatch(startLoadingModuleConfigurationsPaginatedByFilters(pageInitial, itemsPerPage, componentFilterSend));

    } else {
      let isSelectedAnyOtherDifferentThanType = false;
      let isSelectedAnyOtherDifferentThanDataType = false;
      let isSelectedAnyOtherDifferentThanModuleText = false;
      let isSelectedAnyOtherDifferentThanComponentNew = false;
      let isSelectedAnyOtherDifferentThanComponentView = false;
      //Comprobar si los otros no estan seleccionados,
      if (field === 'type') {
        //console.log("A1");
        if (componentFilters.data_type) {
           //console.log("B1");
          isSelectedAnyOtherDifferentThanType = true;
        } else if (componentFilters.module_text) {
           //console.log("C1");
          isSelectedAnyOtherDifferentThanType = true;
        } else if (componentFilters.component_new) {
           //console.log("D1");
          isSelectedAnyOtherDifferentThanType = true;
        } else if (componentFilters.component_view) {
           //console.log("E1");
          isSelectedAnyOtherDifferentThanType = true;
        }
      }else if(field === 'data_type') {
        //console.log("A2");
        if (componentFilters.type) {
           //console.log("B2");
          isSelectedAnyOtherDifferentThanDataType = true;
        } else if (componentFilters.module_text) {
           //console.log("C2");
          isSelectedAnyOtherDifferentThanDataType = true;
        } else if (componentFilters.component_new) {
           //console.log("D2");
          isSelectedAnyOtherDifferentThanDataType = true;
        } else if (componentFilters.component_view) {
           //console.log("E2");
          isSelectedAnyOtherDifferentThanDataType = true;
        }
      }else if(field === 'module_text') {
        //console.log("A3");
        if (componentFilters.type) {
           //console.log("B3");
          isSelectedAnyOtherDifferentThanModuleText = true;
        } else if (componentFilters.data_type) {
           //console.log("C3");
          isSelectedAnyOtherDifferentThanModuleText = true;
        } else if (componentFilters.component_new) {
          // console.log("D3");
          isSelectedAnyOtherDifferentThanModuleText = true;
        } else if (componentFilters.component_view) {
           //console.log("E3");
          isSelectedAnyOtherDifferentThanModuleText = true;
        }
      }else if(field === 'component_new') {
        //console.log("A4");
        if (componentFilters.type) {
           //console.log("B4");
          isSelectedAnyOtherDifferentThanComponentNew = true;
        } else if (componentFilters.data_type) {
           //console.log("C4");
          isSelectedAnyOtherDifferentThanComponentNew = true;
        } else if (componentFilters.module_text) {
           //console.log("D4");
          isSelectedAnyOtherDifferentThanComponentNew = true;
        } else if (componentFilters.component_view) {
           //console.log("E4");
          isSelectedAnyOtherDifferentThanComponentNew = true;
        }
      }else if(field === 'component_view') {
        //console.log("A5");
        if (componentFilters.type) {
           //console.log("B5");
          isSelectedAnyOtherDifferentThanComponentView = true;
        } else if (componentFilters.data_type) {
           //console.log("C5");
          isSelectedAnyOtherDifferentThanComponentView = true;
        } else if (componentFilters.module_text) {
           //console.log("D5");
          isSelectedAnyOtherDifferentThanComponentView = true;
        } else if (componentFilters.component_new) {
           //console.log("E5");
          isSelectedAnyOtherDifferentThanComponentView = true;
        }
      }

      if(!isSelectedAnyOtherDifferentThanType && !isSelectedAnyOtherDifferentThanDataType && 
        !isSelectedAnyOtherDifferentThanModuleText && !isSelectedAnyOtherDifferentThanComponentNew &&
        !isSelectedAnyOtherDifferentThanComponentView
      ){
        setIsDisabledSearchText(false);
      }
      setIsDisabledFilter(false);

      const componentFilterSend = {
        filters: {
          type: componentFilters && componentFilters.type && componentFilters.type.name,
          data_type: componentFilters && componentFilters.data_type && componentFilters.data_type.name,
          module_text: componentFilters && componentFilters.module_text && componentFilters.module_text.name,
          component_new: componentFilters && componentFilters.component_new && componentFilters.component_new.name,
          component_view: componentFilters && componentFilters.component_view && componentFilters.component_view.name,
          [field]: '',
        }
      }

      //console.log("4444, componentFilterSend", componentFilterSend)

      setComponentFilters((values) => ({ ...values, [field]: '' }));

      dispatch(startLoadingModuleConfigurationsPaginatedByFilters(pageInitial, itemsPerPage, componentFilterSend));

    }
  };

  return (
    <>
      <NavbarIconsModuleConfigurations page={"listModuleConfigurations"} />

      <div className="d-flex justify-content-center page-title">{t(`${ID_FORM}.page.${OPERATION}`)}</div>

      <ul className="nav nav-tabs mb-3 justify-content-center">
        <li className="nav-item">
          <button
            type="button"
            className={`nav-link ${activeTab === "list" ? "active" : ""}`}
            onClick={() => setActiveTab("list")}
          >
            {t(`${ID_FORM}.tab.list`)}
          </button>
        </li>
        <li className="nav-item">
          <button
            type="button"
            className={`nav-link ${activeTab === "import" ? "active" : ""}`}
            onClick={() => setActiveTab("import")}
          >
            {t(`${ID_FORM}.tab.import-excel`)}
          </button>
        </li>
      </ul>

      {activeTab === "import" && <ImportModuleConfigExcel />}

      {activeTab === "list" && (
      <div>
      <div className="container">
        <div className="row">

          {/* catalogInstitutionId */}
          {/* Level1 */}
          <div className="col-md-4">
            <label className="form-label label-information">{t(`${ID_FORM}.filter.module_text`)}</label>
            <div className="control">
              <Select
                styles={customStyles}
                myFontSize="14px"
                onChange={(event) => handleChangeComponentFilter(event, 'module_text')}
                classNamePrefix="select"
                name="module_text"
                value={componentFilters.module_text}
                options={listCatalogModules}
                getOptionLabel={(option) => `${option.name}`}
                getOptionValue={(option) => `${option}`}
                isClearable={true}
                isSearchable={true}
                isDisabled={isDisabledFilter}
              />
            </div>
          </div>

          {/* catalogInstitutionId */}
          {/* Level1 */}
          <div className="col-md-4">
            <label className="form-label label-information">{t(`${ID_FORM}.filter.type`)}</label>
            <div className="control">
              <Select
                styles={customStyles}
                myFontSize="14px"
                onChange={(event) => handleChangeComponentFilter(event, 'type')}
                classNamePrefix="select"
                name="type"
                value={componentFilters.type}
                options={listTypeFields}
                getOptionLabel={(option) => `${option.name}`}
                getOptionValue={(option) => `${option}`}
                isClearable={true}
                isSearchable={true}
                isDisabled={isDisabledFilter}
              />
            </div>
          </div>

          {/* catalogInstitutionId */}
          {/* Level1 */}
          <div className="col-md-4">
            <label className="form-label label-information">{t(`${ID_FORM}.filter.data_type`)}</label>
            <div className="control">
              <Select
                styles={customStyles}
                myFontSize="14px"
                onChange={(event) => handleChangeComponentFilter(event, 'data_type')}
                classNamePrefix="select"
                name="data_type"
                value={componentFilters.data_type}
                options={listDataTypes}
                getOptionLabel={(option) => `${option.name}`}
                getOptionValue={(option) => `${option}`}
                isClearable={true}
                isSearchable={true}
                isDisabled={isDisabledFilter}
              />
            </div>
          </div>

          {/* catalogInstitutionId */}
          {/* Level1 */}
          <div className="col-md-4">
            <label className="form-label label-information">{t(`${ID_FORM}.filter.component_new`)}</label>
            <div className="control">
              <Select
                styles={customStyles}
                myFontSize="14px"
                onChange={(event) => handleChangeComponentFilter(event, 'component_new')}
                classNamePrefix="select"
                name="component_new"
                value={componentFilters.component_new}
                options={listComponentNew}
                getOptionLabel={(option) => `${option.name}`}
                getOptionValue={(option) => `${option}`}
                isClearable={true}
                isSearchable={true}
                isDisabled={isDisabledFilter}
              />
            </div>
          </div>

          {/* catalogInstitutionId */}
          {/* Level1 */}
          <div className="col-md-4">
            <label className="form-label label-information">{t(`${ID_FORM}.filter.component_view`)}</label>
            <div className="control">
              <Select
                styles={customStyles}
                myFontSize="14px"
                onChange={(event) => handleChangeComponentFilter(event, 'component_view')}
                classNamePrefix="select"
                name="component_view"
                value={componentFilters.component_view}
                options={listComponentView}
                getOptionLabel={(option) => `${option.name}`}
                getOptionValue={(option) => `${option}`}
                isClearable={true}
                isSearchable={true}
                isDisabled={isDisabledFilter}
              />
            </div>
          </div>

        </div>
      </div>

      <hr className="line-hr" />

      <SearchBackModuleConfiguration
        searchText={searchText}
        setSearchText={setSearchText}
        itemsPerPage={itemsPerPage}
        setIsDisabledSearchText={setIsDisabledSearchText}
        isDisabledSearchText={isDisabledSearchText}
        setIsDisabledFilter={setIsDisabledFilter}
        isDisabledFilter={isDisabledFilter}
      />

      {moduleConfigurationS && moduleConfigurationS.length > 0 ? (
        <TableModuleConfigurations data={moduleConfigurationS} onEditRow={onEditRow} onDeleteRow={onDeleteRow} />
      ) : (
        <TableModuleConfigurations data={moduleConfigurationsP} onEditRow={onEditRow} onDeleteRow={onDeleteRow} />
      )}

      <div>
        <SimpleSelect listOptions={listOptions} onChangeSelect={onChangeSelect} pageSize={itemsPerPage} />
      </div>

      <div className="pagination justify-content-center">
        {moduleConfigurationS && moduleConfigurationS.length > 0 ? (
          <Pagination
            totalPages={totalPagesS}
            totalItems={totalItemsS}
            currentPage={currentPageS + 1}
            itemsPerPage={itemsPerPage}
            onPageChange={onPageChange}
          />
        ) : (
          <Pagination
            totalPages={totalPagesP}
            totalItems={totalItemsP}
            currentPage={currentPageP + 1}
            itemsPerPage={itemsPerPage}
            onPageChange={onPageChange}
          />
        )}
      </div>
      </div>
      )}

    </>
  );
};

export default ListModuleConfigurations;
